import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "../../App.css";
import "./ContactUs.css";
import ContactUsHelper from "../../components/ContactUsHelper/ContactUsHelper";
import { getSignedIn } from "../../handlers/dictionaryHandler.js";
import HeaderBack from "../../components/Header/HeaderBack";

const ContactUs = () => {
  let history = useHistory();

  return (
    <div className="aboutdouble-full-screen">
      <HeaderBack />
      <br />
      <form className="aboutdouble-form">
        <h1 className="h1-homepage">יצירת קשר עם דאבל הכרויות</h1>
        <h2 className="h-nomargin"> איך אפשר לעזור? </h2>
        <ContactUsHelper />
        <Link
          to={getSignedIn() === "1" ? "/questionnaires" : "/"}
          style={{ textDecoration: "none" }}
        >
          <div className="button whiteBackNBorder" id="backBtn">
            {" "}
            <b>→</b>
            חזרה
          </div>
        </Link>
      </form>{" "}
    </div>
  );
};

export default ContactUs;
